import React from 'react';
import { Icon } from '../index';
import * as S from './IconButton.styled';
import { IconButtonProps } from './IconButton.types';

const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>(
  (
    {
      layoutType = 'primary',
      size = 'medium',
      colorType = 'brand',
      disabled,
      iconName,
      iconSize,
      iconColor,
      isActive,
      iconOpacity,
      onClick,
      ...props
    },
    forwardedRef,
  ) => {
    const iconWidth = iconSize ? iconSize : size === 'small' ? 18 : 24;

    return (
      <S.Button
        ref={forwardedRef}
        type='button'
        layoutType={layoutType}
        size={size}
        disabled={disabled}
        colorType={colorType}
        onClick={onClick}
        className={isActive ? 'on' : ''}
        {...props}
      >
        <Icon
          iconName={iconName}
          size={iconWidth}
          color={iconColor}
          opacity={iconOpacity}
        />
      </S.Button>
    );
  },
);

export default IconButton;
